import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { Box, Button, IconButton, Typography } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { useField } from 'formik';
import { v4 as uuid } from 'uuid';
import { TextField } from 'shared/domains/forms';
export function TabularInput() {
    const [field, , helpers] = useField('tabularContent');
    const handleAddColumn = () => {
        helpers.setValue([...field.value, { id: uuid(), name: '', description: '' }]);
    };
    const handleRemoveColumn = (index) => {
        helpers.setValue(field.value.filter((_, i) => i !== index));
    };
    return (<Box flexDirection="column" mb="4xl" bg="background.75" borderRadius="md" p="md">
      <Typography $fontSize="small" $appearance="100" $fontWeight="bold">
        <Trans comment="Prompt library - Tabular review columns title">Columns</Trans>
      </Typography>
      <Box flexDirection="column" gap="md">
        {field.value.map((column, index) => (<Box key={column.id} gap="sm" alignItems="flex-start">
            <Box flexDirection="column">
              <TextField name={`tabularContent[${index}].name`} placeholder={t({ message: 'Column name', comment: 'Prompt library - Tabular review column name' })}/>
            </Box>
            <TextField name={`tabularContent[${index}].description`} placeholder={t({
                message: 'Column prompt',
                comment: 'Prompt library - Tabular review column description',
            })}/>
            <IconButton onClick={() => handleRemoveColumn(index)} appearance="secondary" aria-label={t({ message: 'Remove column', comment: 'Prompt library - Remove tabular review column' })}>
              <Falcon icon="xmark"/>
            </IconButton>
          </Box>))}
        <Button $stretch type="button" onClick={handleAddColumn} appearance="secondary" size="small">
          <Falcon icon="plus"/>
          <Trans comment="Prompt library - Add tabular review column">Add column</Trans>
        </Button>
      </Box>
    </Box>);
}
